var _rect, _g, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 506,
    height: 506,
    rx: 57,
    fill: "url(#paint0_linear)",
    stroke: "url(#paint1_linear)",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 28,
    width: 454,
    height: 456,
    rx: 40,
    fill: "url(#paint2_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.96 282.37L121.33 195.7H120.79L102.16 282.37H139.96ZM145.09 162.22L196.12 355H155.62L146.71 314.23H95.41L86.5 355H46L97.03 162.22H145.09ZM307.624 162.22H184.504V194.08H226.624V355H265.504V194.08H307.624V162.22ZM365.26 326.38V190.84H381.73C389.11 190.84 394.96 192.28 399.28 195.16C403.78 197.86 407.11 202 409.27 207.58C411.61 212.98 413.14 219.82 413.86 228.1C414.58 236.38 414.94 246.01 414.94 256.99C414.94 270.13 414.49 281.11 413.59 289.93C412.87 298.75 411.25 305.86 408.73 311.26C406.39 316.66 403.15 320.53 399.01 322.87C394.87 325.21 389.38 326.38 382.54 326.38H365.26ZM326.38 162.22V355H387.67C400.63 355 411.34 353.02 419.8 349.06C428.26 345.1 435.01 339.07 440.05 330.97C445.09 322.87 448.6 312.61 450.58 300.19C452.74 287.59 453.82 272.83 453.82 255.91C453.82 241.69 453.01 228.82 451.39 217.3C449.77 205.78 446.62 195.97 441.94 187.87C437.44 179.59 431.05 173.29 422.77 168.97C414.49 164.47 403.6 162.22 390.1 162.22H326.38Z",
    fill: "#F9E4B0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 20,
    y: 21,
    width: 486,
    height: 488,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 68.2667,
    y1: -28.4444,
    x2: 585.956,
    y2: 597.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#271827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 83.4783,
    y1: -94.6087,
    x2: 573.217,
    y2: 512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#614C63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 202.872,
    y1: -57.5,
    x2: 192.42,
    y2: 548.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D3C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1523"
  })))));
}

export default __webpack_public_path__ + "images/favicon.svg";
export { SvgFavicon as ReactComponent };